import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { loadMarketingTags } from '../../lib/analytics/marketingTags';

/** La registrazione è un funnel Flusia. Le pagine booking caricano i tag
 *  solo dopo avere risolto l'identità del calendario commerciale dal server. */
export function MarketingTagsController() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname === '/register' || pathname.startsWith('/register/')) {
      loadMarketingTags();
      return;
    }
  }, [pathname]);
  return null;
}
